import { render, staticRenderFns } from "./MultipleFileUploadsAndPreview.vue?vue&type=template&id=c9610ff6"
import script from "./MultipleFileUploadsAndPreview.vue?vue&type=script&lang=js"
export * from "./MultipleFileUploadsAndPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports